import { Controller } from "react-hook-form";
import { TextField, TextFieldProps } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FormTextFieldProps {
    name: string,
    control: any,
    props: TextFieldProps,
    matcher ?: RegExp
}

export const FormTextField = ({ name, control, props, matcher }: FormTextFieldProps) => {

    const { t } = useTranslation('finance');

    return (
            <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) =>
                            <TextField {...props} {...field}
                                        onChange={(e)=>{
                                            props.onChange?.(e);
                                            if((!!matcher && !!e.target.value && e.target.value.match(matcher)) || !matcher || e.target.value.length === 0)
                                                field.onChange(e);
                                        }}
                                       onBlur={(e)=>{
                                           props.onBlur?.(e);
                                           field.onBlur();
                                       }}
                                       error={!!error}
                                       helperText={(error && error.type === 'required' && t('forms.required-field', { label: props.label })) || error?.message}
                            />
                    }
            />
    );
}

export default FormTextField;